export default "__VITE_ASSET__lCtar$Ck__"